import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "group p-2 rounded-full bg-white/10 hover:bg-white/20 backdrop-blur-md transition-all duration-300 border sm:border-white/20 hover:scale-105 active:scale-95" }
const _hoisted_2 = { class: "max-h-[460px] overflow-y-scroll px-4" }
const _hoisted_3 = { class: "flex flex-col gap-6" }
const _hoisted_4 = { class: "space-y-4" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "pt-3 px-1 text-[13px] text-gray-500 font-medium animate-in fade-in slide-in-from-top-1 duration-200 pb-3 border-b border-gray-300 rounded-b-lg"
}
const _hoisted_7 = { class: "space-y-4" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  class: "pt-3 px-1 text-[13px] text-gray-500 font-medium animate-in fade-in slide-in-from-top-1 duration-200 pb-3 border-b border-gray-300 rounded-b-lg"
}

import { ref } from "vue"
import { ChevronDown, CircleQuestionMark } from "lucide-vue-next"
import {
    Popover,
    PopoverTrigger,
    PopoverContent,
} from "@/components/ui/popover"
import { ScrollArea } from "@/components/ui/scroll-area"

interface FaqItem {
    title: string
    body: string
    isOpen: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AuthFaqPopover',
  setup(__props) {

const creators = ref<FaqItem[]>([
    {
        title: "How can User Generating Content creation benefit my career?",
        body: "Creating UGC for brands allows you to build a strong portfolio, gain exposure, and work with reputable companies. It’s an excellent way to develop your skills, grow your audience, and earn income.",
        isOpen: false,
    },
    {
        title: "How are my rights protected at TAWA Content Factory?",
        body: "The brand receives the full version of your content only after approval and payment. At the end of each campaign, your payment is securely processed, ensuring you are fairly compensated for your work.",
        isOpen: false,
    },
    {
        title: "How can I increase my chances of getting selected?",
        body: "Complete your profile, upload high-quality portfolio examples, and apply to opportunities aligned with your skills to stand out.",
        isOpen: false,
    },
    {
        title: "How do I know what brands expect?",
        body: "Each request includes a detailed brief with guidelines, themes, and key messages so you can deliver content aligned with expectations.",
        isOpen: false,
    },
])

const brands = ref<FaqItem[]>([
    {
        title: "What is User Generated Content and why is it valuable?",
        body: "UGC is authentic content created by real creators instead of brands. It increases trust, engagement, and relatability.",
        isOpen: false,
    },
    {
        title: "Can TAWA connect me with aligned creators?",
        body: "Yes. You gain access to a diverse pool of vetted creators across industries and styles.",
        isOpen: false,
    },
    {
        title: "How does TAWA streamline campaigns?",
        body: "Manage briefs, applications, approvals, private requests, and performance tracking in one platform.",
        isOpen: false,
    },
    {
        title: "How are campaign results measured?",
        body: "You receive detailed KPIs including engagement rates, reach, conversion data, and performance insights.",
        isOpen: false,
    },
])

function toggle(list: FaqItem[], index: number) {
    list.forEach((item, i) => {
        item.isOpen = i === index ? !item.isOpen : false
    })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Popover), null, {
    default: _withCtx(() => [
      _createVNode(_unref(PopoverTrigger), { "as-child": "" }, {
        default: _withCtx(() => [
          _createElementVNode("button", _hoisted_1, [
            _createVNode(_unref(CircleQuestionMark), { class: "h-5 w-5 text-gray-400 sm:text-white group-hover:rotate-12 transition-transform duration-300" })
          ])
        ]),
        _: 1
      }),
      _createVNode(_unref(PopoverContent), {
        align: "end",
        side: "bottom",
        class: "w-[90vw] sm:w-[420px] p-0 rounded-2xl border border-gray-200/60 bg-white/80 backdrop-blur-sm shadow-2xl"
      }, {
        default: _withCtx(() => [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "px-6 pt-6 pb-3 mb-2 border-b border-gray-200/60" }, [
            _createElementVNode("h3", { class: "text-sm font-semibold text-gray-600 tracking-tight" }, " Frequently Asked Questions "),
            _createElementVNode("p", { class: "text-xs text-gray-400 mt-1" }, " Everything you need to know about working with TAWA. ")
          ], -1)),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, [
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex items-center gap-2 mb-4" }, [
                  _createElementVNode("h4", { class: "text-xs font-semibold bg-clip-text text-transparent bg-gradient-to-br from-[#999cff] to-[#bc44aa] uppercase tracking-wider" }, " For Creators ")
                ], -1)),
                _createElementVNode("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(creators.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: 'creator-' + index
                    }, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (toggle(creators.value, index)),
                        class: "w-full text-left text-sm font-medium text-gray-600 flex justify-between items-start group hover:scale-[1.01] hover:translate-x-1 transition-all duration-200 hover:text-purple-500"
                      }, [
                        _createElementVNode("span", null, _toDisplayString(item.title), 1),
                        _createVNode(_unref(ChevronDown), {
                          class: _normalizeClass(["w-4 h-4 shrink-0 text-gray-600 transition-transform duration-300 group-hover:text-purple-500", item.isOpen ? 'rotate-180' : 'rotate-0'])
                        }, null, 8, ["class"])
                      ], 8, _hoisted_5),
                      (item.isOpen)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(item.body), 1))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ]),
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "border-t border-gray-200/70" }, null, -1)),
              _createElementVNode("div", null, [
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex items-center gap-2 mb-4" }, [
                  _createElementVNode("h4", { class: "text-xs font-semibold bg-clip-text text-transparent bg-gradient-to-br from-[#999cff] to-[#bc44aa] uppercase tracking-wider" }, " For Brands ")
                ], -1)),
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(brands.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: 'brand-' + index
                    }, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (toggle(brands.value, index)),
                        class: "w-full group text-left text-sm font-medium text-gray-600 flex justify-between items-start hover:scale-[1.01] hover:translate-x-1 transition-all duration-200 hover:text-purple-500"
                      }, [
                        _createElementVNode("span", null, _toDisplayString(item.title), 1),
                        _createVNode(_unref(ChevronDown), {
                          class: _normalizeClass(["w-4 h-4 shrink-0 text-gray-600 transition-transform duration-300 group-hover:text-purple-500", item.isOpen ? 'rotate-180' : 'rotate-0'])
                        }, null, 8, ["class"])
                      ], 8, _hoisted_8),
                      (item.isOpen)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(item.body), 1))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "px-6 py-4 border-t border-gray-200/60 text-center" }, [
            _createElementVNode("p", { class: "text-[11px] text-gray-400" }, " Still have questions? Contact our support team. ")
          ], -1))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})